import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { AlertCircle } from "lucide-react";

function formatCurrency(v) { return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(v); }

export function RestockAlerts({ alerts }) {
  if (!alerts?.length) return null;
  return (
    <Card className="border-none shadow-soft overflow-hidden" data-testid="restock-alerts">
      <div className="bg-red-500/10 border-b border-red-200 dark:border-red-900 px-5 py-3">
        <div className="flex items-center gap-2">
          <AlertCircle className="w-5 h-5 text-red-700 dark:text-red-400" />
          <h3 className="font-semibold text-sm text-red-800 dark:text-red-300">
            Alertas de reposicion — {alerts.length} ingrediente{alerts.length > 1 ? "s" : ""} con stock insuficiente
          </h3>
        </div>
      </div>
      <CardContent className="p-0">
        <div className="divide-y">
          {alerts.map((alert, i) => {
            const isCritical = alert.severity === "critical";
            const isWarning = alert.severity === "warning";
            return (
              <div
                key={`alert-${alert.name}-${i}`}
                className={`flex items-center gap-4 px-5 py-3 ${isCritical ? "bg-red-50/50 dark:bg-red-950/10" : isWarning ? "bg-amber-50/50 dark:bg-amber-950/10" : ""}`}
                data-testid={`restock-alert-${i}`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                  isCritical ? "bg-red-100 dark:bg-red-900/30" : isWarning ? "bg-amber-100 dark:bg-amber-900/30" : "bg-blue-100 dark:bg-blue-900/30"
                }`}>
                  <AlertCircle className={`w-4 h-4 ${
                    isCritical ? "text-red-700" : isWarning ? "text-amber-700" : "text-blue-600"
                  }`} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-sm">{alert.name}</span>
                    <Badge variant={isCritical ? "destructive" : isWarning ? "secondary" : "outline"} className="text-[10px] px-1.5 py-0">
                      {isCritical ? "Critico" : isWarning ? "Bajo" : "Info"}
                    </Badge>
                  </div>
                  <div className="flex items-center gap-3 mt-0.5 text-xs text-muted-foreground">
                    <span>Stock: {alert.current_stock} {alert.unit}</span>
                    <span>Necesario: {alert.total_needed} {alert.unit}</span>
                    <span>Cobertura: {alert.coverage_pct}%</span>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-bold text-sm font-mono">{alert.to_purchase} {alert.unit}</div>
                  <div className="text-xs text-muted-foreground">
                    {alert.estimated_cost > 0 ? formatCurrency(alert.estimated_cost) : "—"}
                  </div>
                </div>
                <div className="w-16 shrink-0">
                  <div className="h-1.5 bg-accent dark:bg-gray-700 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full ${isCritical ? "bg-red-500" : isWarning ? "bg-amber-500" : "bg-blue-500"}`}
                      style={{ width: `${Math.min(alert.coverage_pct, 100)}%` }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="border-t px-5 py-3 bg-muted/30 flex items-center justify-between">
          <span className="text-xs text-muted-foreground">
            {alerts.filter(a => a.severity === "critical").length} criticos,{" "}
            {alerts.filter(a => a.severity === "warning").length} bajos
          </span>
          <span className="text-sm font-bold font-mono">
            Total compra: {formatCurrency(alerts.reduce((s, a) => s + (a.estimated_cost || 0), 0))}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
